<template>
  <div class="selection-card-layout flex flex-col items-center text-center h-full">
    <KIcon
      v-if="icon"
      :name="icon"
      class="
        mb-4
        md:mb-12
        w-10
        md:w-20
        h-8
        md:h-16
        fill-current
        text-primary
      "
    />
    
    <template v-if="image">
      <div
        v-if="image.isIcon"
        class="selection-card-layout__icon-area"
      >
        <div
          v-dompurify-html:svg="dynamicIconSource"
          class="selection-card-layout__dynamic-icon"
        />
      </div>
      <img
        v-else
        :alt="image.alt"
        :src="image.source"
        class="selection-card-layout__image h-full w-full rounded-t-lg"
        :class="{ 'max-h-[50%]': !image.isIcon }"
      />
    </template>

    <div class="selection-card-layout__content">
      <div
        v-if="title"
        class="selection-card-layout__title"
      >
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IconName, iconNames } from '@/components/atoms/Icon/icons'
import KIcon from '@/components/atoms/Icon/index.vue';
import KImage from '@/types/KImage'
import useRemoteIcon from '@/hooks/useRemoteIcon'

export default defineComponent({
  name: 'SelectionCardLayout',
  components: { KIcon },
  props: {
    image: {
      type: Object as () => KImage,
      required: false
    },
    icon: {
      type: String as () => IconName,
      required: false,
      validator: (value: string | undefined) =>
        value ? iconNames.includes(value) : true
    },
    title: {
      type: String,
      required: false
    },
    body: {
      type: String,
      required: false
    }
  },
  setup (props) {
    const dynamicIconSource = props.image?.isIcon && props.image.source
      ? useRemoteIcon(props.image.source)
      : null

    return { dynamicIconSource }
  }
})
</script>

<style>
.selection-card-layout {
  &__content {
    @apply flex w-full flex-1 flex-col items-center justify-center px-4;
    min-height: 0;
  }

  &__title {
    @apply text-base md:text-xl font-bold;
  }

  &__icon-area {
    @apply flex items-center justify-center w-full;
    max-height: 50%;
    height: 50%;        
  }

  &__dynamic-icon {
    svg {
      @apply mb-4 w-10 h-8 fill-current text-primary;
    }
  }

  &__image {
    @apply max-w-full -mx-6;
    max-height: 78px;
  }
}

@screen md {
  .selection-card-layout {
    &__dynamic-icon {
      svg {
        @apply w-20 h-16;
      }
    }

    &__image {
      max-height: 146px;
    }
  }
}
</style>
